import React, { useMemo, useState } from 'react';
import contentsData from '../assets/contents_alab.json';
import globalContentsData from '../assets/contents_global_alab.json';
import ContentGridCard from '../components/section/ContentGridCard';
import {
  PageGrid,
  PageHeader,
  PageHeaderText,
  PageLabel,
  PageTitle,
  PageWrapper,
  Tab,
  TabGroup,
} from '../components/section/pageLayout';
import { SectionInner } from '../components/section/common';
import PageContainer from '../view/page-container';
import { dedupeContentItems, type ContentItem } from '../utils/listingData';

const ContentsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'korea' | 'global'>('korea');
  const koreaItems = contentsData as ContentItem[];
  const globalItems = globalContentsData as ContentItem[];

  const visibleItems = useMemo(() => {
    const source = activeTab === 'korea' ? koreaItems : globalItems;
    return dedupeContentItems(source);
  }, [activeTab, koreaItems, globalItems]);

  return (
    <PageContainer>
      <PageWrapper>
        <SectionInner>
          <PageHeader>
            <PageHeaderText>
              <PageLabel>CONTENTS</PageLabel>
              <PageTitle>콘텐츠</PageTitle>
            </PageHeaderText>
            <TabGroup>
              <Tab
                style={{ color: activeTab === 'korea' ? '#CEDA87' : '#555555' }}
                $active={activeTab === 'korea'}
                type="button"
                onClick={() => setActiveTab('korea')}
              >
                Korea
              </Tab>
              <Tab
                style={{
                  color: activeTab === 'global' ? '#CEDA87' : '#555555',
                }}
                $active={activeTab === 'global'}
                type="button"
                onClick={() => setActiveTab('global')}
              >
                Global
              </Tab>
            </TabGroup>
          </PageHeader>

          <PageGrid>
            {visibleItems.map((item, index) => (
              <ContentGridCard
                key={`${item.content_url}-${index}`}
                item={item}
              />
            ))}
          </PageGrid>
        </SectionInner>
      </PageWrapper>
    </PageContainer>
  );
};

export default ContentsPage;
